import { reRoomyTermsExtended } from './apps/re-roomy/reRoomyExtended';
import { iMealTermsExtended } from './apps/i-meal/iMealExtended';
import { tcgScannerTermsExtended } from './apps/tcg-scanner/tcgScannerExtended';

/** Full terms page content per app slug. Missing slug → /{slug}/terms-of-use shows 404. */
export function getTermsPageContent(appSlug) {
  if (appSlug === 're-roomy') {
    return reRoomyTermsExtended;
  }
  if (appSlug === 'i-meal') {
    return iMealTermsExtended;
  }
  if (appSlug === 'tcg-scanner') {
    return tcgScannerTermsExtended;
  }
  return null;
}
